import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
 "inline-flex items-center rounded-full px-3 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
 {
 variants: {
 variant: {
 default:
 "bg-primary text-primary-foreground hover:bg-primary/80",
 secondary:
 "bg-secondary text-secondary-foreground hover:bg-secondary/80",
 destructive:
 "bg-destructive text-destructive-foreground hover:bg-destructive/80",
 outline: "border border-input text-foreground",
 success: "bg-green-500 text-white",
 "success-outline": "border border-green-500 text-green-500 bg-transparent",
 warning: "bg-amber-500 text-white",
 info: "bg-blue-500 text-white",
 pending: "bg-muted text-muted-foreground",
 },
 },
 defaultVariants: {
 variant: "default",
 },
 }
)

export interface BadgeProps
 extends React.HTMLAttributes<HTMLDivElement>,
 VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
 return (
 <div className={cn(badgeVariants({ variant }), className)} {...props} />
 )
}

export { Badge, badgeVariants }
